export const styles = `
    .chat-container {
        position: fixed;
        bottom: 16px;
        right: 16px;
        width: 350px;
        height: 500px;
        background: white;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
        padding: 16px;
        border-radius: 12px;
        font-family: Arial, sans-serif;
        display: flex;
        flex-direction: column;
        }
        .chat-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 8px;
        border-bottom: 1px solid #ddd;
        }
        .chat-messages {
        flex-grow: 1;
        overflow-y: auto;
        margin-bottom: 10px;
        padding: 10px;
        border-radius: 8px;
        background: #f7f7f7;
        display: flex;
        flex-direction: column;
        }
        .message {
        padding: 12px;
        margin: 6px 0;
        border-radius: 12px;
        max-width: 70%;
        word-wrap: break-word;
        display: inline-block;
        }
        .bot-message {
        background: #e5e7eb;
        align-self: flex-start;
        box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
        }
        .user-message {
        background: #3b82f6;
        color: white;
        align-self: flex-end;
        text-align: right;
        box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
        }
        .input-container {
        display: flex;
        align-items: center;
        gap: 8px;
        }
        .input-field {
        flex: 1;
        padding: 10px;
        border: 2px solid #ddd;
        border-radius: 8px;
        font-size: 14px;
        }
        .send-button {
        background: #3b82f6;
        color: white;
        padding: 10px;
        border-radius: 8px;
        cursor: pointer;
        transition: background 0.3s;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        }
        .send-button:hover {
        background: #2563eb;
        }
        .chat-button {
        position: fixed;
        bottom: 20px;
        right: 20px;
        background: #ff6600;
        color: white;
        padding: 14px;
        border-radius: 50%;
        cursor: pointer;
        width: 55px;
        height: 55px;
        }
        .close-button {
        cursor: pointer;
        width: 24px;
        height: 24px;
        }
    .option-buttons {
        display: flex;
        gap: 10px;
        margin-top: 10px;
        justify-content: center;
    }

    .option-button {
        background: #1E40AF; /* Rich blue for a sleek look */
        color: white;
        padding: 10px 18px; /* Adjusted padding for a refined shape */
        border-radius: 8px; /* Softer corners */
        font-size: 14px; /* Decreased font size for a cleaner appearance */
        font-weight: 500;
        cursor: pointer;
        border: none;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.15); /* Subtle shadow for depth */
        transition: background 0.3s, transform 0.2s, box-shadow 0.2s;
    }

    .option-button:hover {
        background: #2563eb; /* Slightly lighter blue on hover */
        transform: translateY(-2px); /* Smooth lift effect */
        box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.2);
    }

    .option-button:active {
        transform: translateY(1px);
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
    }
    .image-selection {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
        gap: 10px;
        justify-items: center;
        width: 100%;
        max-width: 100%;
        margin-top: 10px;
    }

    .gift-card-image {
        width: 80px; 
        height: 80px;
        object-fit: cover;
        border-radius: 8px;
        cursor: pointer;
        transition: transform 0.2s ease-in-out;
    }

    .gift-card-image:hover {
        transform: scale(1.1);
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
    }
`;

export default styles;
